module.exports = __webpack_public_path__ + "img/health18_7-9-2021.bb540376.jpg";